import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store/store';

const selectSelectedCategoryName = (state: RootState) => state.Consumables.selectedCategoryName;
const selectSelectedTypeName = (state: RootState) => state.Consumables.selectedTypeName;
const selectSearchQuery = (state: RootState) => state.Consumables.searchQuery;
const selectConsumablesProducts = (state: RootState) => state.Consumables.products;
const selectFilteredConsumablesProducts = (state: RootState) => state.Consumables.filteredConsumablesProducts;
const selectCategories = (state: RootState) => state.Consumables.categories;
const selectTypes = (state: RootState) => state.Consumables.types;
const selectConsumablesStateLoaded = (state: RootState) => state.Consumables.consumablesStateLoaded;
const selectProductSubscriptions = (state: RootState) => state.Consumables.consumablesProductSubscriptions;
const selectHasProductSubscriptions = createSelector(
  selectProductSubscriptions,
  subscriptions => !!subscriptions && !!subscriptions.length
);
const selectConsumablesOrders = (state: RootState) => state.Consumables.consumablesOrders;
const selectShowConsumablesOnboardingFlow = createSelector(
  selectConsumablesStateLoaded,
  selectConsumablesOrders,
  (consumablesStateLoaded, consumablesOrders) =>
    consumablesStateLoaded && (!consumablesOrders || consumablesOrders.length === 0)
);
const selectShowOnboardingCartToast = (state: RootState) => state.Consumables.showOnboardingCartToast;
const selectCartToastZIndex = (state: RootState) => state.Consumables.cartToastZIndex;
const selectHideToastTimeoutId = (state: RootState) => state.Consumables.hideToastTimeoutId;
const selectResetZIndexTimeoutId = (state: RootState) => state.Consumables.resetZIndexTimeoutId;
export {
  selectSelectedCategoryName,
  selectSelectedTypeName,
  selectSearchQuery,
  selectConsumablesProducts,
  selectFilteredConsumablesProducts,
  selectCategories,
  selectTypes,
  selectConsumablesStateLoaded,
  selectProductSubscriptions,
  selectConsumablesOrders,
  selectHasProductSubscriptions,
  selectShowOnboardingCartToast,
  selectCartToastZIndex,
  selectHideToastTimeoutId,
  selectResetZIndexTimeoutId,
  selectShowConsumablesOnboardingFlow
};

export const selectDeliveryFees = (state: RootState) => state.Consumables.deliveryFees;
